<div class="container">
  <form #loginForm="ngForm" (ngSubmit)="onSubmit()">
    
    <div class="form-section">
      <h2>Log In</h2>

      <div class="form-group">
        <label for="userName">Username <span class="required">*</span></label>
        <input
          type="text"
          id="userName"
          name="userName"
          required
          placeholder="Username..."
          [(ngModel)]="loginData.username"
          #userName="ngModel"
          [class.invalid]="userName.invalid && userName.touched"
          [class.valid]="userName.valid && userName.touched"
        />
        <div class="error" *ngIf="userName.invalid && userName.touched">
          Username is required.
        </div>
      </div>

      <div class="form-group">
        <label for="password">Password <span class="required">*</span></label>
        <input
          type="password"
          id="password"
          name="password"
          required
          placeholder="Password..."
          [(ngModel)]="loginData.password"
          #password="ngModel"
          [class.invalid]="password.invalid && password.touched"
          [class.valid]="password.valid && password.touched"
        />
        <div class="error" *ngIf="password.invalid && password.touched">
          Password is required.
        </div>
        <div class="invalid-login-message" *ngIf="showInvalidLoginMessage">
          Invalid username or password
        </div>
      </div>


    <div class="button-group">
        <button type="submit" class="btn-primary" [disabled]="loginForm.invalid">
            Login
        </button>    
    </div>
    </div>
  </form>
</div>

